import React from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
	Card,
	CardBody,
	CardTitle,
	Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Row
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import Switch from "react-switch";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { auth } from '../../Api'
import ReactLoading from 'react-loading';
import CompanyEdit from './company-edit';
import ContentModal from '../../components/contentModal';
import { AutoComplete, Input as AInput, Pagination } from 'antd';
import LocalPhoneField from '../../components/people/localPhoneField'
import { dialCodeFor, toInternational, phoneProblem, formatPhone } from '../../utils/phone'
import { formatServerMessage } from '../../utils/serverErrors'
import DeleteCompanyModal from '../../components/companies/deleteCompanyModal'
import { titleCell } from '../../utils/tables'
import { rememberAccount, accountTypeLabel, COMPANY, PRIVATE, PRIVATE_ACCOUNTS_PATH } from '../../utils/accountType'

const TreeTable = treeTableHOC(ReactTable);

const { getCode, getName } = require('country-list');

class ReSellers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked: false,
			open: -1,
			modal: false,
			alertModal: false,
			alertActiveModal: false,
			contentModal: false,
			activeLoading: false,
			contentMessage: "",
			obj: {},
			jsonData: [],
			originData: [],
			data: data.makeData(),
			treedata: data.treedata,
			defaultPageSize:10,
		};
		this.toggle = this.toggle.bind(this);
		this.alertToggle = this.alertToggle.bind(this);
		this.alertActiveToggle = this.alertActiveToggle.bind(this);
		this.contentToggle = this.contentToggle.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onVisible = this.onVisible.bind(this);
		// What is typed in Search (kept when the list is loaded again), and when the list was last asked for (ms)
		this.searchValue = '';
		this.loadedAt = 0;
	}
	componentDidMount() {
		var defaultPageSize = localStorage.getItem('defaultPageSize')
		if(defaultPageSize!=undefined){
			this.setState({
				defaultPageSize: defaultPageSize
			})
		}
		this.loadCompanies()
		document.addEventListener('visibilitychange', this.onVisible)
	}

	componentWillUnmount() {
		document.removeEventListener('visibilitychange', this.onVisible)
	}

	// Back on this browser tab: the list again, so a company suspended or reinstated meanwhile (a payment, the
	// overdue run) shows at once. Not while a dialog is open or the switch is busy, and not more than once in 5 seconds.
	onVisible() {
		const { modal, alertModal, alertActiveModal, contentModal, activeLoading } = this.state
		if (document.visibilityState !== 'visible' || modal || alertModal || alertActiveModal || contentModal || activeLoading
			|| Date.now() - this.loadedAt < 5000) {
			return
		}
		this.loadCompanies()
	}

	// The search typed so far applies to the list as loaded
	searched(users) {
		const value = this.searchValue.toLowerCase()
		return value === '' ? users : users.filter((prop) => prop.name.toLowerCase().includes(value))
	}

	loadCompanies() {
		this.loadedAt = Date.now()
		var admin_level = localStorage.getItem('admin_level')
		var admin_id = localStorage.getItem('admin_id')
		var req = {}
		console.log("admin_level:", admin_level, admin_id)
		if (admin_level != "a")
			req.admin_id = admin_id
		console.log(req)
		auth.getCompany(req)
			.then((res) => {
				console.log("res company:", res)
				if (res.data.code == 200) {
					this.setState({
						jsonData: this.searched(res.data.message.users),
						originData: res.data.message.users,
						totalCount: res.data.message.users.length
					})
				}
			});
	}

	componentDidUpdate() {
		console.log("called setState function");
	}

	toggle() {
		console.log("clicked toggle function")
		this.setState({
			modal: !this.state.modal
		});
	}
	alertToggle() {
		this.setState({
			alertModal: !this.state.alertModal
		});
	}
	contentToggle() {
		this.setState({
			contentModal: !this.state.contentModal
		});
	}
	alertActiveToggle() {
		this.setState({
			alertActiveModal: !this.state.alertActiveModal
		});
	}
	handleChange(index, prop) {
		console.log("checked:", index)
		let { jsonData, alertActiveModal } = this.state;
		if (prop.active == 0)
			auth.activeCompany(prop)
				.then((res) => {
					this.loadCompanies()
				})
		else
			this.setState({
				alertActiveModal: !alertActiveModal,
				obj: prop
			})
	}

	// The phone as typed (the field shows it at once); completed with the dialling code on Save
	setPhoneNumber = (text) => {
		let { obj } = this.state;
		obj.phoneTyped = text
		this.forceUpdate()
	}

	handleSubmit = (event) => {
		event.preventDefault();
		let { obj } = this.state;
		// Send only the fields this modal edits - never the whole row, and never a password. A Private account's name
		// is the person's full name, changed in its own "Your details"
		const isPrivate = obj.account_type === PRIVATE
		let req = {
			id: obj.id,
			email: event.target.email.value
		};
		if (!isPrivate) req.name = event.target.name.value;
		if (obj.countrycode != null) req.countrycode = obj.countrycode;
		if (obj.phoneTyped != null) {
			// The local number completed with the company's dialling code; the server does the same
			const dialCode = dialCodeFor(obj.countrycode)
			const phonenumber = toInternational(obj.phoneTyped, dialCode)
			if (!phonenumber) {
				window.alert(phoneProblem(obj.phoneTyped, dialCode))
				return
			}
			req.phonenumber = phonenumber
		}
		console.log('company update req:', req);
		auth.updateCompany(req)
			.then((res) => {
				console.log("res:", res);
				if (res.data.code == 200) {
					if (req.name !== undefined) obj.name = req.name;
					obj.email = req.email;
					if (req.phonenumber) obj.phonenumber = req.phonenumber;
					delete obj.phoneTyped;
					// Saved: back to the list, showing it
					this.setState({ jsonData: [...this.state.jsonData], modal: false })
				} else {
					this.setState({
						contentModal: true,
						contentMessage: formatServerMessage(res.data.message, "Update failed. Please try again.")
					})
				}
			})
			.catch(() => {
				this.setState({
					contentModal: true,
					contentMessage: "Could not reach the server. Please try again."
				})
			})
		// The form stays open until the company is saved
	}

	goDetail(prop) {
		localStorage.setItem('companyId', prop.id)
		localStorage.setItem('companyName', prop.name)
		rememberAccount(prop)
		this.props.history.push('/company/company-view/' + prop.id)
	}

	// The server has deleted the company (components/companies/deleteCompanyModal): its row goes at once
	companyDeleted = (company) => {
		this.setState({
			jsonData: this.state.jsonData.filter((x) => x.id != company.id),
			alertModal: false,
			contentModal: true,
			contentMessage: company.account_type === PRIVATE ? 'The account and everything it owned have been deleted' : 'The company and everything it owned have been deleted'
		})
	}

	activeRow() {
		console.log("res after delete:")

		let { obj, activeLoading } = this.state;
		this.setState({ activeLoading: true })
		if (obj.active == 0)
			auth.activeCompany(obj)
				.then((res) => {
					this.setState({
						alertActiveModal: !this.state.alertActiveModal
					})
					this.loadCompanies()
				})
		else
			auth.stopCompany(obj)
				.then((res) => {
					this.setState({
						alertActiveModal: !this.state.alertActiveModal
					})
					this.loadCompanies()
				})
		this.setState({ activeLoading: false })

	}
	goEdit() {
		localStorage.removeItem('companyId')
		this.props.history.push("/company-edit");
	}

	goDetailPage(index, prop) {
		localStorage.setItem('companyId', prop.id)
		localStorage.setItem('companyName', prop.name)
		rememberAccount(prop)
		let urlLst = ["/company-dashboard", "/district", "/guards",
			"/supervisor", "/clients", "/alert-template", "/billing"]
		this.props.history.push(urlLst[index])
	}

	handleSearch = (value) => {
		this.searchValue = value
		console.log(["searchData.length==value:", value])
		var searchData = [];
		this.state.originData.map((prop, key) => {
			if (prop.name.toLowerCase().includes(value.toLowerCase())) {
				searchData.push(prop)
			}
		})
		console.log(["searchData.length==00:", searchData.length])
		this.setState({ jsonData: searchData })
	};

	onSizeChange = (size,page) => {
		console.log("size,page::",size,page)
		localStorage.setItem('defaultPageSize',size)
		this.setState({
			defaultPageSize:size
		})
	}

	// The super admin's two menu items, one page: Companies (Company accounts only) and Private accounts (/private-accounts)
	privateList() {
		return !!(this.props.location && this.props.location.pathname === PRIVATE_ACCOUNTS_PATH)
	}

	render() {
		const { data, obj, activeLoading, defaultPageSize } = this.state;
		const superAdmin = localStorage.getItem('admin_level') === 'a'
		const privateList = this.privateList()
		// A reseller's list has all their accounts, with the Type column
		const listed = !superAdmin ? this.state.jsonData
			: this.state.jsonData.filter((prop) => (prop.account_type === PRIVATE ? PRIVATE : COMPANY) === (privateList ? PRIVATE : COMPANY))
		const data2 = listed.map((prop, key) => {
			if (prop.active == 1) prop.active = true
			if (prop.active == 0) prop.active = false
			const isPrivate = prop.account_type === PRIVATE
			return {
				id: key,
				name: (
					<div onClick={() => { prop.active == 1 ? this.goDetail(prop) : console.log("") }}
						className={prop.active ? "activeCompany" : "stopCompany"} style={{ cursor: "pointer" }}><a>{prop.name}</a></div>
				),
				type: accountTypeLabel(prop.account_type),
				country: getName(prop.countrycode),
				phonenumber: formatPhone(prop.phonenumber),
				email: prop.email,
				timezone: prop.timezone,
				actions: (
					// we've added some custom button actions
					<div className="text-center">
						{activeLoading ? <ReactLoading type={"bars"} color={"#3399ff"} height={'30'} width={'66'} />
							: <span title={prop.active ? 'Active: switch off to suspend this company' : 'Suspended: switch on to reinstate this company'}>
								<Switch onChange={() => this.handleChange(key, prop)} uncheckedIcon checkedIcon offColor="#ddd"
									checked={prop.active}
								/></span>}
					</div>
				),
				edit: (
					<div className="justify-content-center">
						<Button className="btn-table-edit ml-2" onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:", key, obj.name]);
							this.setState({
								modal: !this.state.modal,
								obj: prop,
							});
						}}><i className="mdi mdi-lead-pencil" style={{ color: "white" }} /></Button>
						<Button className="btn-table-remove ml-1" onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:", key, obj.name]);
							this.setState({
								alertModal: !this.state.alertModal,
								obj: prop,
							});
						}}><i className="fas fa-trash-alt" style={{ color: "white" }} /></Button>
					</div>
				),
				linkPage: (
					<div className="panel panel-default">
						<div className="panel-heading">
							<h6 className="panel-title">
								<a onClick={function () {
									console.log(this.state.open)
									if (key == this.state.openKey)
										this.setState({ openKey: -1 })
									else
										this.setState({ openKey: key })
								}.bind(this)} ><i className="fas fa-plus"></i>&nbsp;View</a>
							</h6>
						</div>
						<div className={this.state.openKey == key ? "panel-collapse" : "panel-collapse panel-close"}>
							<div className="list-group">
								<a onClick={() => { this.goDetailPage(0, prop) }} style={{ cursor: "pointer" }}><i className="mdi mdi-view-dashboard mr-10"></i>&nbsp;Dashboard</a>
								{/* A Private account has no districts, supervisors or clients */}
								{!isPrivate && <a onClick={() => { this.goDetailPage(1, prop) }} style={{ cursor: "pointer" }}><i className="ti-map-alt mr-10"></i>&nbsp;Districts</a>}
								<a onClick={() => { this.goDetailPage(2, prop) }} style={{ cursor: "pointer" }}><i className="icon-shield mr-10"></i>&nbsp;Guards</a>
								{!isPrivate && <a onClick={() => { this.goDetailPage(3, prop) }} style={{ cursor: "pointer" }}><i className="mr-2 mdi mdi-account-alert mr-10"></i>&nbsp;Supervisors</a>}
								{!isPrivate && <a onClick={() => { this.goDetailPage(4, prop) }} style={{ cursor: "pointer" }}><i className="mr-2 mdi mdi-account-multiple-outline mr-10"></i>&nbsp;Clients</a>}
								{/* Alert templates are shared by every company: the super admin's sidebar link (Alert Templates) */}
								<a onClick={() => { this.goDetailPage(6, prop) }} style={{ cursor: "pointer" }}><i className="icon-chart mr-10"></i>&nbsp;Billing</a>
							</div>
						</div>
					</div>
				)
			};
		});

		console.log("defaultPageSize=========:",defaultPageSize)

		return <div>
			<Modal isOpen={this.state.modal} toggle={this.toggle}>
				<ModalHeader toggle={this.toggle}><h3>Company Edit</h3></ModalHeader>
				{
					obj == {} ? <div></div> : <ModalBody>
						<Form onSubmit={this.handleSubmit}>
							{/* <Input type="hidden" name="id" id="id" defaultValue={obj.id} /> */}
							{obj.account_type === PRIVATE ? (
								<FormGroup>
									<Label>Name</Label>
									<div>{obj.name} <small className="text-muted">(a private account: the owner changes their name in Your details)</small></div>
								</FormGroup>
							) : (
								<FormGroup>
									<Label for="name">Company Name</Label>
									<Input type="text" name="name" id="name" defaultValue={obj.name} />
								</FormGroup>
							)}
							<FormGroup>
								<Label for="email">Email</Label>
								<Input type="text" name="email" id="email" defaultValue={obj.email} />
							</FormGroup>
							<FormGroup>
								<Label for="age">Phone</Label>
								<LocalPhoneField
									dialCode={dialCodeFor(obj.countrycode)}
									value={obj.phoneTyped != null ? obj.phoneTyped : obj.phonenumber}
									onChange={this.setPhoneNumber} />
							</FormGroup>
							<FormGroup style={{ textAlign: "center" }}>
								<Button color="primary" className="modal-btn mr-1" type="submit">Save</Button>
								<Button color="secondary" className="modal-btn ml-1" onClick={this.toggle}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>}
			</Modal>
			<DeleteCompanyModal
				isOpen={this.state.alertModal}
				company={this.state.obj}
				onCancel={this.alertToggle}
				onDeleted={this.companyDeleted} />
			<Modal isOpen={this.state.alertActiveModal} toggle={this.alertActiveToggle}>
				{/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					<h2>{this.state.obj && this.state.obj.account_type === PRIVATE ? 'Are you sure you want to suspend this account?' : 'Are you sure you want to suspend this company?'}</h2>
					<div className="height-10"></div>
					<FormGroup>
						<Button color="secondary" className="modal-btn ml-1" onClick={this.alertActiveToggle}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" className="modal-btn mr-1" onClick={() => this.activeRow()}>Yes, suspend it</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			<Modal isOpen={this.state.contentModal} toggle={this.contentToggle}>
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					<h2>{this.state.contentMessage}</h2>
					<div className="height-10"></div>
					<FormGroup>
						<Button color="secondary" className="modal-btn ml-1" onClick={this.contentToggle}>OK</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			{/*--------------------------------------------------------------------------------*/}
			{/* Start Action table*/}
			{/*--------------------------------------------------------------------------------*/}

			<Card>
				<CardBody>
					{/* Private accounts start on the public sign-up page */}
					{!privateList && <div className="add-button add-button-top">
						<a onClick={() => this.goEdit()}><Button className="btn" color="primary" size="lg" active>
							<i className="fas fa-user-plus"></i> Add New Company
						</Button></a>
					</div>}
					<Row className="table-header">
						<div className="table-title"><i className="fas fa-users"></i><span> {privateList ? 'Private accounts' : 'Companies'}</span></div>
						<div style={{ width: 300 }} className="auto-complete">
							<AutoComplete
								dropdownMatchSelectWidth={252}
								style={{
									width: 300,
								}}
								options={[]}
								onSearch={this.handleSearch}
							>
								<AInput size="large" placeholder="Search" />
							</AutoComplete>
						</div>
					</Row>
					<ReactTable
						columns={[
							{
								Header: "No",
								id: "row",
								maxWidth: 50,
								filterable: false,
								Cell: (row) => {
									return <div>{row.index + 1}</div>;
								}
							},
							{
								Header: privateList || !superAdmin ? "NAME" : "COMPANY",
								accessor: "name"
							},
							// Company or Private (utils/accountType.js): in a reseller's list, which has both (the super admin has a list of each)
							...(!superAdmin ? [{
								Header: "TYPE",
								accessor: "type",
								minWidth: 80,
								maxWidth: 90,
							}] : []),
							{
								Header: "PHONE",
								accessor: "phonenumber",
								Cell: titleCell,
							},
							{
								Header: "EMAIL",
								accessor: "email",
								Cell: titleCell,
							},
							{
								Header: "Timezone",
								accessor: "timezone",
								Cell: titleCell,
							},
							{
								Header: "ACTIVE",
								accessor: "actions",
								minWidth: 66,
								sortable: false,
								maxWidth: 66,
								filterable: false
							},
							{
								Header: "RELATED PAGES",
								accessor: "linkPage",
								minWidth: 160,
								// id: "row",
								maxWidth: 160,
								filterable: false,
							},
							{
								Header: "",
								accessor: "edit",
								minWidth: 120,
								id: "row",
								maxWidth: 120,
								justfyContent: "center",
								filterable: false,
							},
						]}
						showPaginationBottom={true}
						pageSize={defaultPageSize}
						pageSizeOptions={[5, 10, 15, 20, 30, 40, 50]}
						onPageSizeChange={(size,number)=>this.onSizeChange(size,number)}
						className="-striped -highlight"
						data={data2}
					// filterable
					/>
				</CardBody>
			</Card>
			{/*--------------------------------------------------------------------------------*/}
			{/* End Action table*/}
			{/*--------------------------------------------------------------------------------*/}
		</div>
	}
}

export default ReSellers;
